export const getProfileOptions = (state) => state.bp.profileOptions;
export const getDefaultProfileId = (state) => state.bp.defaultProfileId;
export const getSelectedProfileId = (state) => state.bp.selectedProfileId;
